<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :btnFlag="false" :buttonFlag="false">
        <template slot="button">
          <div>
            <el-button type="primary" size="mini" @click="addOrgin(6)">数据备份</el-button>
            <el-button type="primary" size="mini" @click="addOrgin(7)">下载备份</el-button>
            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
              刷新
            </el-button>
          </div>
        </template>
      </v-button>
      <div class="page_content_top_line">
        <el-form :inline="true" class="demo-form-inline" size="mini" label-width="100px">
          <el-form-item label="开始时间">
            <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
            <!-- 开始时间 -->
            <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
            <el-date-picker class="form_codition" size="mini" @click="changeTime" v-model="getRequestData.end" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="page_content_center">
      <el-table stripe :data="returnData.list" border style="width: 100%" :height="tableHeight" highlight-current-row size="mini">
        <el-table-column align="center" label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fileName" label="文件名称" min-width="200"></el-table-column>
        <el-table-column align="center" prop="createTime" label="备份时间" :show-overflow-tooltip="true" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">
              {{ $common.getLocalTime(scope.row.createTime, true) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: 100,
      getRequestData: {
        ormId: '',
        start: '',
        end: '',
        page: 1,
        rows: 10,
      },
      returnData: {
        list: [],
        total: 0,
      },
      selectedDataIndex: 0,
    }
  },
  created() {
  },
  methods: {
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1
        this.getRequestData.end = time
      }
    },
    //按钮控制
    addOrgin(type) {
      switch (type) {
        case 6://数据备份
          this.OrganizationbackUpOrmData()
          break;
        case 7://备份查询
          if (this.returnData.list <= 0) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          console.log(`${this.$store.getters.getConfig.requestUrl}/Organization/downOrmDataFile?ocId=${dataInfo.ocId}`);
          window.location.href = `${this.$store.getters.getConfig.requestUrl}/Organization/downOrmDataFile?ocId=${dataInfo.ocId}`
          break;
      }
    },
    async OrganizationbackUpOrmData() {
      let ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId
      const responseData = await this.$http.OrganizationbackUpOrmData({
        ormId: ormId
      })
      console.log(responseData);
      if (responseData.status == 200) {
        this.getDataList();
        this.$message.success("备份成功")
      } else {
        this.$message.error(responseData.message)
      }
    },
    //刷新
    getPageInfo() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    //检索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList();
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },
    //列表渲染
    async getDataList() {
      const responseData = await this.$http.OrganizationqueryBackUpOrmData(this.getRequestData)
      console.log(responseData);
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.total = responseData.result.total
      }
    }
  },
  mounted() {
    var day = 30
    if (JSON.parse(sessionStorage.getItem('printInfo')).days) {
      day = JSON.parse(sessionStorage.getItem('printInfo')).days
    }
    this.getRequestData.start = new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000
    this.getRequestData.end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
    this.getRequestData.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId
    this.getDataList()
  },
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
}
</script>

<style></style>